module.exports = __webpack_public_path__ + "static/media/ditto.5660c815.jpeg";